import React, {useEffect, useMemo, useRef, useState} from "react";
import {Option, Options, SelectWrapper, Selected} from "./styles";
import icon from '../../../assets/images/reservation/drop-down-arrow.svg';
import {ClickAwayListener} from "@mui/material";
import PropTypes from "prop-types";

const Select = props => {
    const { value, options, onChange, hint, error, freeText, inputRef, disabled } = props;
    const [open, setOpen] = useState(false);
    const [text, setText] = useState('');
    const wrapperRef = useRef();

    const onClick = e => {
        e.stopPropagation();
        setOpen(!open);
    }

    const selected = useMemo(() => options.find(item => item.value == value)?.label, [options, value]);

    const filteredOptions = useMemo(() => {
        if(text === '' || !freeText) {
            return options;
        }
        return options.filter(item => item.label.toLowerCase().includes(text.toLowerCase()));
    }, [options, text, freeText]);

    useEffect(() => {
        if(selected && freeText) {
            setText(selected);
        }
        if(!selected){
            setText('')
        }
    }, [selected, freeText]);

    if(inputRef) {
        inputRef.current = {focus: () => {
                setOpen(true);
            }}
    }

    return (<ClickAwayListener onClickAway={() => { if(open) setOpen(false)}}>
        <SelectWrapper ref={wrapperRef} onClick={onClick} disabled={disabled ? disabled : false} >
            <select value={value || undefined} >
                {/* i added the key value to option */}
                {options.map(option => <option value={option.value} key={option.value} />)}
            </select>
            <Selected empty={value === null} opened={open} error={error}>
                {freeText ? <input placeholder={hint} value={text} onChange={e => {
                        setText(e.target.value);
                        onChange(e.target.value);
                    }} /> :
                    <span>{!selected ? (value || hint || '') : selected}</span>}
                <img src={icon} alt="dd-icon"/>
            </Selected>
            <Options opened={open && filteredOptions.length > 0} disabled={disabled ? disabled : false}>
                {filteredOptions.map(option => (<Option
                    key={`select-option-${option.value}`}
                    selected={value === option.value} isNewOption={option.isNewOption}
                    onClick={() => onChange(option.value)}>{option.label}</Option>))}
            </Options>
        </SelectWrapper>
    </ClickAwayListener>);
}

Select.propTypes = {
    value: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func,
    hint: PropTypes.string,
    error: PropTypes.bool,
    freeText: PropTypes.bool,
    inputRef: PropTypes.object,
    disabled: PropTypes.bool,
}

export default Select;
